import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import { LOCALE_ID } from '@angular/core';

import { NgxPageScrollModule } from 'ngx-page-scroll';
import { DlDateTimePickerDateModule } from 'angular-bootstrap-datetimepicker';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AuthGuard } from './_guards/auth.guard';
import { NeedSearchUserGuard } from './_guards/needSearchUser.guard';
import { NeedSecretariaGuard } from './_guards/needSecretaria.guard';
import { AdminPermissionGuard } from './_guards/adminPermission.guard';
import { CercarAlumnesPermissionGuard } from './_guards/cercarAlumnesPermission.guard';
import { CercarFillsPermissionGuard } from './_guards/cercarFillsPermission.guard';

import { AlertComponent } from './_directives/alert.component';
import { WelcomeComponent } from './welcome.component';
import { NotFoundComponent } from './notFound.component';
import { NoPermissionComponent } from './components/blocks/nopermission.component';
import { HeaderComponent } from './components/blocks/header.component';
import { FooterComponent } from './components/blocks/footer.component';
import { SidebarComponent } from './components/blocks/sidebar.component';
import { BodyComponent } from './components/blocks/body.component';
import { LoginComponent } from './components/login/login.component';

import { AlertService } from './_services/alert.service';
import { LogService} from './_services/logmanager.service';
import { AppConfig } from './app.config';
import { getBaseLocation } from './app.config';
import { AuthenticationService } from './_services/authentication.service';
import { DataService } from './_services/datamanager.service';
import { LoginControl } from './_services/logincontrol.service';
import { APP_BASE_HREF } from '@angular/common';

import { AlertModule } from 'ngx-bootstrap';
import { PipesModule } from './modules/pipes/pipe-module';

import { FileUploadService } from 'app/_services/fileuploadservice.service';
import { FileDownloadService } from 'app/_services/filedownloadservice.service';
import { GlobalsService } from 'app/_services/globals.service';
import { SecretariaConfigService } from './_services/secretariaconfig.service';

import localeCa from '@angular/common/locales/ca';
import { ConsultesCsvModule } from './components/consultes-csv/consultes-csv.module';
registerLocaleData(localeCa);

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        AppRoutingModule,
        HttpClientModule,
        HttpClientJsonpModule,
        NgxPageScrollModule,
        PipesModule,
        DlDateTimePickerDateModule,
        AlertModule.forRoot(),
        ConsultesCsvModule,
        BrowserAnimationsModule,
    ],
    declarations: [
        AppComponent,
        LoginComponent,
        AlertComponent,
        WelcomeComponent,
        NotFoundComponent,
        NoPermissionComponent,
        HeaderComponent,
        SidebarComponent,
        FooterComponent,
        BodyComponent
    ],
    providers: [
        AppConfig,
        { provide: APP_BASE_HREF, useFactory: getBaseLocation },
        { provide: LOCALE_ID, useValue: 'ca' },
        AlertService,
        LogService,
        AuthGuard,
        NeedSearchUserGuard,
        NeedSecretariaGuard,
        AdminPermissionGuard,
        CercarAlumnesPermissionGuard,
        CercarFillsPermissionGuard,
        AuthenticationService,
        DataService,
        LoginControl,
        FileUploadService,
        FileDownloadService,
        GlobalsService,
        SecretariaConfigService
    ],
    bootstrap: [ AppComponent ]
})

export class AppModule {}
